import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import unfoldIcon from '../assets/icon/jiantou_geren_icon.png';
import foldIcon from '../assets/icon/heijiantou_geren_icon.png';
import { BoxDiv } from './box';
import jdyf from '../assets/img/jdyf_geren_icon.png';
import Definition1 from './definition1';
import ClassicPrescription from './classic-prescription';

const Section = styled(BoxDiv)`
  border: none;
  height:485px;
  border-bottom: 1px solid #f0f0f0;
  padding: 34px 40px 41px 60px;
  page-break-inside: avoid;
  background-image:url(${jdyf});
  background-repeat:no-repeat;
  background-position:20px center;
  background-size:711px 450px;
  position:relative;
`;
const ScreenOnly = styled.div`
  @media print {
    display: none;
  }
`;
const ItemName = styled.span`
  display: inline-block;
  width: 115px;
  font-size: 26px;
  line-height: 1;
  text-align: right;
  color: #666666;
`;
const Unfold = styled(ScreenOnly)`
  margin: 0;
  text-align: center;
  position:absolute;
  left:0px;
  right:0px;
  bottom:50px;
`;
const Fold = styled(ScreenOnly)`
  margin: 8px auto 0 auto;
  padding-bottom:16px;
  text-align: center;
  width: 100%;
  font-size: 25px;
  color: #666;
  background-color:#fff;
`;
const div1 = {
    backgroundColor: '#fff',
    paddingTop:'40px'

};
class ClassicPrescription2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            folded: false,
        };
        this._onUnfold = this._onUnfold.bind(this);
        this._onFold = this._onFold.bind(this);
    }
    getmaxscore(arrayobj) {
        let maxi = 0;
        for (let i = 0; i < arrayobj.length; i++) {
            if (arrayobj[maxi].score <= arrayobj[i].score) {
                maxi = i;
            }
        }
        return arrayobj[maxi].name;
    }
    _onUnfold() {
        this.setState({ folded: true });
    }
    _onFold() {
        this.setState({ folded: false });
        if (this.containerRef) {
            const { top } = this.containerRef.getBoundingClientRect();

            window.scroll(0, window.scrollY + top);
        }
    }

    renderUnfoldAnchor() {
        if (this.state.folded) return null;
        return (
            <Unfold onClick={this._onUnfold}>
                <ItemName style={{ margin: 0, fontSize: '25px', minWidth: 0 }}>
                    查看详情
                </ItemName>
                <img
                    src={unfoldIcon}
                    alt='unfold'
                    style={{
                        height: '18px',
                        marginLeft: '5px',
                    }}
                />
            </Unfold>
        );
    }
    renderFoldAnchor() {
        if (!this.state.folded) return null;
        return (
            <Fold onClick={this._onFold}>
                收起全部
                <img
                    src={foldIcon}
                    alt='fold'
                    style={{
                        height: '15px',
                        marginLeft: '10px',
                    }}
                />
            </Fold>
        );
    }
    renderOneSection(symptomName) {
        const { solutions } = this.props.examination;
        if (!solutions) return null;

        const explaining = solutions.prescription;
        const jdyf1 = explaining[symptomName];
        if (
            !explaining ||
            !explaining[symptomName]
        ) return null;
        return (
            <div>
                {jdyf1.map((e, i) => (
                    // eslint-disable-next-line react/no-array-index-key


                    <Definition1
                        name={e.name} />

                ))}
            </div>


        );
    }

    renderMore() {
        const { symptoms } = this.props.examination;
        if (symptoms[0].name === '健康') return null;
        const symptomsName = this.getmaxscore(symptoms);
        return [
            (this.state.folded) ?
                <div style={div1} > <ClassicPrescription
                    examination={this.props.examination}
                />
                    {this.renderFoldAnchor()}
                </div>
                :
                <Section >
                    {this.renderOneSection(symptomsName)}
                    {this.renderUnfoldAnchor()}
                </Section>
        ];
    }
    render() {
        return (
            <div>
                {this.renderMore()}
            </div>
        );
    }
}

ClassicPrescription2.propTypes = {
    examination: PropTypes.object.isRequired,
};

export default ClassicPrescription2;



// WEBPACK FOOTER //
// ./src/components/classic-prescription2.jsx